var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "230px",
    height: "115px",
    viewBox: "-55 -27.5 230 115",
    enableBackground: "new -55 -27.5 230 115",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -54,
    y: -21.726,
    fill: "#656668",
    width: 18.278,
    height: 12.875
  }), /*#__PURE__*/React.createElement("rect", {
    x: -54,
    y: -1.995,
    fill: "#656668",
    width: 18.278,
    height: 55.668
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#656668",
    d: "M3.62,36.223v-25.96h14.748V-1.993H3.62V-21.58h-18.278v19.584h-11.526v12.256h11.526v28.146 c0,10.071,1.663,16.514,19.004,16.514c4.053,0,10.907-0.625,14.333-1.041V41.628c-2.908,0.206-5.712,0.411-8.933,0.411 C4.969,42.039,3.62,40.586,3.62,36.223"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.724,
    y: -21.596,
    fill: "#656668",
    width: 4.776,
    height: 75.269
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#656668",
    d: "M82.22-0.611v4.265c12.523,2.641,18.8,12.949,18.8,23.428c0,12.153-8.411,24.096-25.234,24.096 c-16.825,0-25.237-11.943-25.237-24.096c0-10.343,6.118-20.505,18.302-23.308v-4.297C54.133,2.291,45.772,14.056,45.772,27.083 c0,14.957,11.012,28.247,30.013,28.247c19.006,0,30.016-13.292,30.016-28.247C105.798,13.909,97.246,2.032,82.22-0.611"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#656668",
    d: "M144.715,48.896c-15.785,0-24.718-8.31-24.718-23.468c0-15.372,11.629-22.433,24.197-22.433 c15.576,0,25.029,8.311,25.029,22.327C169.224,41.417,158.529,48.896,144.715,48.896 M169.224,0.5v10.803l-0.208-0.109 c-5.086-9.762-15.263-12.357-24.818-12.357c-20.252,0-28.979,12.881-28.979,26.792c0,14.225,8.208,27.422,28.875,27.422 c11.212,0,20.25-3.951,24.922-12.778h0.208v11.013c0,9.865-3.635,21.079-24.3,21.079c-15.582,0-21.604-5.295-22.746-13.708h-4.779 c1.764,12.983,11.008,17.863,27.523,17.863c24.712,0,29.078-13.297,29.078-25.445V0.5H169.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF3B3D",
    d: "M78.274,12.032c0,1.623-1.229,2.939-2.742,2.939c-1.511,0-2.738-1.316-2.738-2.939v-25.925 c0-1.623,1.228-2.938,2.738-2.938c1.514,0,2.742,1.315,2.742,2.938V12.032z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItlog);
export default __webpack_public_path__ + "static/media/itlog.d2eeecec945df707743ac9b3c2a31567.svg";
export { ForwardRef as ReactComponent };